import type { NextPage } from "next";
import PageLayout from "@components/PageLayout";

import ClaimEL from "@components/ClaimELV2";

const ClaimELPage: NextPage = () => {
  return (
    <PageLayout extraMarginTop={false}>
      <ClaimEL />
    </PageLayout>
  );
};

export default ClaimELPage;
